import React from "react";
import TermsOfUse from "../components/TermsOfUse";

function TermsOfUsePage() {
  return <TermsOfUse />;
}

export default React.memo(TermsOfUsePage);
